export const FACILITY_TIMEZONES = [
    { value: 'US/Eastern', label: 'Eastern (US/Eastern)' },
    { value: 'US/Central', label: 'Central (US/Central)' },
    { value: 'US/Mountain', label: 'Mountain (US/Mountain)' },
    { value: 'US/Pacific', label: 'Pacific (US/Pacific)' },
];

export const DEFAULT_FACILITY_TIME_ZONE = 'US/Central';
